import { type FC } from 'react';
import AppCard from './AppCard';
import { UiIconHardDrives } from '@/lib/ui';

export interface ContentHubProps {
  navLink?: string
  isSelected?: boolean
  isEnabled?: boolean
}

const ContentHubCard: FC<ContentHubProps> = ({
  navLink = undefined,
  isSelected = false,
  isEnabled = false,
}) => {
  return (
    <AppCard
      navLink={navLink}
      icon={(<UiIconHardDrives size={'3xl'} color={isEnabled ? 'green.500' : 'gray.800'} />)}
      name={'On-demand content hosting'}
      isSelected={isSelected}
    />
  );
};
export default ContentHubCard;
